import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from "../../utils/set_title";
import { BASE_URL, api } from "../../utils";


export default function ContentGenFile() {
	SetTitle('Content Gen - Download File')
	const params = useParams()

	useEffect(() => {
		downloadData()
	}, [])

	const downloadData = () => {
		if (params?.id) {
			api.get('get-content-gen-file/' + params.id, { responseType: 'blob' })
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					const contentDisposition = response.headers['content-disposition'];
					let fileName = 'content_gen_file.xlsx';
					if (contentDisposition) {
						const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
						if (fileNameMatch.length === 2)
							fileName = fileNameMatch[1];
					}
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					link.remove();
					setTimeout(() => {
						window.location.href = '/content-gen'
					}, 5000)
				})
				.catch((error) => {
					console.error("Download failed:", error);
					setTimeout(() => {
						window.location.href = '/content-gen'
					}, 5000)
				});
		}
		else {
			setTimeout(() => {
				window.location.href = '/content-gen'
			}, 1000)
		}
	}

	return (
		<>
			<div className="bg-gradient-info secondary-page-title" >
				<div md={12} className="form-title">
					<i className="ni ni-folder-17 text-white" style={{ color: "white", fontSize: "35px" }}></i>
					<h1 className="page-title">Content Gen</h1>
				</div>
			</div>
			<div className="page-description">Download in corso...</div>
		</>
	)
}
